import { css, unsafeCSS } from '@Root/lib/lit-3form-block';

export const gridClassMiscDriverSuffix = '--with-misc';

export const styles = [
  css`
    :host {
      --nav-border-style: 1px solid #c0c0c0;
    }

    img {
      padding-top: calc(10em / var(--default-rem-px-count));
    }

    h2 {
      font-size: calc(16em / var(--default-rem-px-count));
      line-height: calc(24em / var(--default-rem-px-count));
      letter-spacing: -0.21px;
      font-weight: 500;
    }

    h3 {
      font-size: calc(14em / var(--default-rem-px-count));
      line-height: calc(24em / var(--default-rem-px-count));
      letter-spacing: -0.24px;
      font-weight: 500;
    }

    p,
    li {
      font-size: calc(14em / var(--default-rem-px-count));
      line-height: calc(32em / var(--default-rem-px-count));
      letter-spacing: -0.24px;
      padding: calc(4em / var(--default-rem-px-count)) 0;
    }

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
    }

    a {
      text-decoration: none;
      color: inherit;
    }

    .nav-wrapper {
      max-width: 1440px;
      margin: 0 auto;
      padding: calc(30em / var(--default-rem-px-count)) 0;
    }

    :host .nav-grid {
      grid-template-rows:
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto);
    }

    .nav-grid {
      display: inline-grid;
      grid-template-columns: repeat(6, auto);
      padding: 0 var(--between-column-padding);
    }

    /* SEGMENTS */
    .segments {
      display: grid;
      grid-template-rows: auto;
      gap: calc(16em / var(--default-rem-px-count));
      grid-template-columns: repeat(
        3,
        calc(100% / 3 - calc(12em / var(--default-rem-px-count)))
      );
      grid-column: 1 / 6;
      padding-bottom: calc(16em / var(--default-rem-px-count));
    }

    .segment-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .segment {
      max-width: 100%;
    }

    .segment img {
      width: 100%;
    }

    .segment-driver p:hover,
    .misc-driver p:hover {
      text-decoration: underline;
    }

    .segment-description {
      display: none;
    }

    /* MISC DRIVERS */
    .misc-drivers {
      grid-column: 1 / 6;
      grid-row: 2;
      display: flex;
      flex-direction: row;
      padding-bottom: calc(50em / var(--default-rem-px-count));
      padding-top: calc(16em / var(--default-rem-px-count));
      border-top: var(--nav-border-style);
      margin-top: calc(16em / var(--default-rem-px-count));
    }

    .misc-driver-vertical-rule {
      display: none;
    }

    .driver-section {
      width: 50%;
    }

    p.driver-section-title {
      font-weight: 500;
    }

    /* CTAS */
    .ctas {
      grid-column: 1 / 6;
      grid-row: 3;
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 0 var(--between-column-padding);
      width: calc(100% - var(--between-column-padding));
    }

    .mobile-panels-wrapper {
      display: flex;
      flex-direction: row;
      height: -webkit-fill-available;
      width: 100vw;
    }

    .hidden {
      visibility: hidden;
    }

    .first-mobile-panel,
    .second-mobile-panel {
      width: 100vw;
    }

    .mobile-panels-wrapper section {
      display: flex;
      flex-direction: column;
      transition: all 0.15s linear;
      will-change: transform;
    }

    .mobile-panels-wrapper section.slid {
      margin-left: -100vw;
    }

    .second-mobile-panel {
      flex-basis: 0px;
      flex-grow: 1;
      overflow-y: auto;
      height: fit-content;
    }

    .mobile-header {
      height: calc(50em / var(--default-rem-px-count));
      border-bottom: var(--nav-border-style);
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 var(--between-column-padding);
    }

    .mobile-header img {
      transform: rotate(180deg);
      padding: 0;
    }

    .mobile-header h2 {
      padding-left: calc(20em / var(--default-rem-px-count));
    }

    .mobile-footer {
      display: flex;
      flex-direction: row;
      padding: calc(16em / var(--default-rem-px-count))
        calc(8em / var(--default-rem-px-count))
        calc(50em / var(--default-rem-px-count))
        calc(8em / var(--default-rem-px-count));

      border-top: var(--nav-border-style);
      margin: 0 var(--between-column-padding);
      max-width: 100vw;
    }

    .mobile-footer ul {
      width: 50%;
    }

    .mobile-footer ul img {
      max-width: 80%;
      padding: 0;
    }

    .elements-logo {
      height: calc(14em / var(--default-rem-px-count));
    }

    .lightart-logo,
    .threeform-logo {
      height: calc(16em / var(--default-rem-px-count));
    }

    .first-mobile-panel {
      height: -webkit-fill-available;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .top-level-items {
      padding-top: calc(16em / var(--default-rem-px-count));
      padding-left: calc(16em / var(--default-rem-px-count));
      margin: auto 0;
    }

    .top-level-items li {
      font-weight: 500;
      padding-bottom: calc(24em / var(--default-rem-px-count));
      cursor: pointer;
    }

    /* DESKTOP */
    @media (min-width: 1024px) {
      p {
        font-size: calc(14em / var(--default-rem-px-count));
        line-height: calc(20em / var(--default-rem-px-count));
        letter-spacing: -0.24px;
        padding: 0 0 calc(12em / var(--default-rem-px-count)) 0;
      }

      .nav-grid {
        grid-template-columns:
          var(--outer-padding)
          repeat(12, [col] var(--column-width))
          var(--outer-padding);

        gap: 0 var(--between-column-padding);
      }

      :host .nav-grid {
        grid-template-rows:
          minmax(0, auto)
          minmax(0, auto);
      }

      .top-level-items {
        padding-top: 0;
      }

      /* One segment per row */
      .one-segment {
        grid-column: 7 / 9;
        grid-template-columns: repeat(1, 1fr);
      }
      .one-segment${unsafeCSS(gridClassMiscDriverSuffix)} {
        grid-column: 7 / 9;
        grid-template-columns: repeat(1, 1fr);
      }

      /* Two segments per row */
      .two-segments {
        grid-column: 6 / 10;
        grid-template-columns: repeat(2, 1fr);
      }
      .two-segments${unsafeCSS(gridClassMiscDriverSuffix)} {
        grid-column: 6 / 10;
        grid-template-columns: repeat(2, 1fr);
      }

      /* Three segments per row */
      .three-segments {
        grid-column: 5 / 11;
        grid-template-columns: repeat(3, 1fr);
      }
      .three-segments${unsafeCSS(gridClassMiscDriverSuffix)} {
        grid-column: 5 / 11;
        grid-template-columns: repeat(3, 1fr);
      }

      /* Four segments per row */
      .four-segments {
        grid-column: 4 / 12;
        grid-template-columns: repeat(4, 1fr);
      }
      .four-segments${unsafeCSS(gridClassMiscDriverSuffix)} {
        grid-column: 3 / 11;
        grid-template-columns: repeat(4, 1fr);
      }

      /* Five segments per row */
      .five-segments {
        grid-column: 3 / 13;
        grid-template-columns: repeat(5, 1fr);
      }
      .five-segments${unsafeCSS(gridClassMiscDriverSuffix)} {
        grid-column: 2 / 12;
        grid-template-columns: repeat(5, 1fr);
      }

      /* Six segments per row */
      .six-segments {
        grid-column: 2 / 14;
        grid-template-columns: repeat(6, 1fr);
      }

      .segments {
        display: grid;
        grid-template-rows: auto;
        gap: var(--between-column-padding);
        padding-bottom: calc(30em / var(--default-rem-px-count));
        border-bottom: none;
        margin-bottom: 0;
      }

      .segment-drivers {
        padding-top: calc(10em / var(--default-rem-px-count));
      }

      .segment-description {
        display: initial;
        padding-top: calc(5em / var(--default-rem-px-count));
        font-weight: calc(12em / var(--default-rem-px-count));
      }

      .misc-drivers {
        grid-column: 12 / 14;
        grid-row: 1;
        flex-direction: column;
        justify-content: start;
        padding-top: 0;
        border-top: none;
        margin-top: 0;
      }

      .misc-driver-vertical-rule {
        display: inherit;
        grid-column: 11;
        grid-row: 1;
        border-left: var(--nav-border-style);
        margin: 0 auto;
      }

      .driver-section {
        width: 100%;
      }

      .driver-section:first-child {
        padding-bottom: calc(24em / var(--default-rem-px-count));
      }

      .ctas {
        grid-column: 2 / 14;
        grid-row: 2;
      }

      .mobile-header {
        display: none;
      }

      .mobile-footer {
        display: none;
      }
    }
  `,
];
